import { Autocomplete, CircularProgress, Stack, TextField } from '@mui/material';
import { compact, filter, includes, isEmpty, map } from 'es-toolkit/compat';
import React from 'react';

import { useEncodedFilters } from 'utils/useEncodedFilters';
import useStudyReportOptions from './useStudyReportOptions';

interface Props {
  selectedStudyIds: string[];
  disabled?: boolean;
}

const StudyReportStudySelector: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  selectedStudyIds,
  disabled = false,
}) => {
  const { studyOptions, studiesLoading } = useStudyReportOptions();
  const { setQueryParams, queryParams } = useEncodedFilters();

  const options: any[] = studyOptions || [];
  const selectedValues = filter(options, (option) => includes(selectedStudyIds, option?.value));

  return (
    <Stack spacing={1} sx={{ maxWidth: 540 }}>
      <Autocomplete
        multiple
        size="small"
        disabled={disabled}
        options={options}
        value={selectedValues}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Studies"
            helperText={disabled ? 'Create a study to enable report selection.' : undefined}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {studiesLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        getOptionLabel={(option) => option.text || ''}
        isOptionEqualToValue={(option, value) => option?.value === value?.value}
        onChange={(_event, selected) => {
          const ids = compact(map(selected, (opt: any) => opt?.value));
          setQueryParams(
            { filters: { ...queryParams.filters, studyId: !isEmpty(ids) ? ids : undefined }, page: 1 },
            'replaceIn'
          );
        }}
      />
    </Stack>
  );
};

export default StudyReportStudySelector;
